<template>
  <CalculatorScoreboardLayout v-if="isCalculatorApplicant" />
  <ScoreboardLayout v-else />
</template>
<script>
import CalculatorScoreboardLayout from './CalculatorScoreboardLayout';
import ScoreboardLayout from './ScoreboardLayout';
import { mapGetters } from 'vuex';
/**
 * This component defines a common page layout with slots for:
 * - A Header
 * - A Menu
 * - A Footer
 */
export default {
  name: 'InternalLayout',
  data() {
    return {
      menuOpen: true,
      menuMini: true
    };
  },
  computed: {
    ...mapGetters({
      calculatorApplicant: 'vehicleApplication/isCalculatorApplicant'
    }),
    isCalculatorApplicant() {
      return this.calculatorApplicant;
    }
  },
  mounted() {},
  components: {
    CalculatorScoreboardLayout,
    ScoreboardLayout
  }
};
</script>
